import React, { useMemo } from "react";
// import ReactMapGL, { Marker, Popup, Layer, Source } from "react-map-gl";
import ReactMapGL, { Marker, Layer, Source } from "react-map-gl";
import clsx from "clsx";

function AtidimMap({
  index,
  device,
  objects,
  polygon,
  configToken,
  configStyle,
  center,
  zoom,
}) {
  objects = objects.filter((obj) => {
    return obj.deviceId === device;
  }).length;
  function calcPolygonCenter(pointsList, x) {
    let sum = 0;
    let list = Array.from(pointsList);
    for (let i = 0; i < list.length - 1; i++) {
      sum += list[i][x];
    }
    return sum / (list.length - 1);
  }

  const viewport = {
    zoom: zoom[0],
    bearing: 0,
    pitch: 0,
  };
  const settings = {
    dragPan: false,
    dragRotate: false,
    scrollZoom: false,
    touchZoom: false,
    touchRotate: false,
    keyboard: false,
    doubleClickZoom: false,
  };
  const MAPBOX_TOKEN = configToken; // Set your mapbox token here
  const MAP_STYLE = configStyle;
  const mapPylgonsNumber = useMemo(
    () => (
      <Marker
        key={index}
        longitude={calcPolygonCenter(polygon, 0)}
        latitude={calcPolygonCenter(polygon, 1)}
        offsetTop={-8}
        offsetLeft={0}
      >
        <span className="text-blue-900 text-lg font-semibold">{objects}</span>
      </Marker>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [objects]
  );

  const mapPolygon = useMemo(
    () => (
      <Source
        key={index}
        type="geojson"
        data={{
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [polygon],
          },
        }}
      >
        <Layer
          type="line"
          paint={{
            "line-color": "rgb(30, 58, 138)",
            "line-width": 1.5,
            // "line-opacity": 0.3,
            "line-dasharray": [1, 2, 3],
          }}
        />
        <Layer
          type="fill"
          paint={{
            "fill-color": "#75a3ff",
            "fill-opacity": 0.5,
          }}
        />
      </Source>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return (
    <div className="w-44 h-36 rounded-md ">
      <div className=" w-full h-full flex items-center">
        <ReactMapGL
          key={index}
          {...viewport}
          {...settings}
          attributionControl={false}
          latitude={center["lat"]}
          longitude={center["lon"]}
          width={"100%"}
          height={"100%"}
          getCursor={() => "default"}
          className={clsx(
            "rounded-xl text-xs border-4 border-white transition-all w-full "
          )}
          mapStyle={MAP_STYLE}
          onViewportChange={viewport}
          mapboxAccessToken={MAPBOX_TOKEN}
          onLoad={(e) => {
            e.target.resize();
          }}
          onRender={(e) => {
            e.target.resize();
          }}
          onResize={(e) => {
            e.target.resize();
          }}
          onData={(e) => {
            e.target.resize();
          }}
          onStyleData={(e) => {
            e.target.resize();
          }}
          // mapOptions={{ hash: true }}
        >
          {mapPylgonsNumber}
          {mapPolygon}
        </ReactMapGL>
      </div>
    </div>
  );
}

export default AtidimMap;
